import { useCallback, useContext, useEffect, useRef } from 'react';
import useCustomHook from '@/hooks/useCustomHook';

export default function useChronometer({ game, tick, alarm, audioRef }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      minutes: 0,
      seconds: 0,
    },
    actions: {},
  });
  const secondsRef = useRef(0);

  const update = useCallback(() => {
    if (!game.state.finished) {
      const seconds = secondsRef.current + 1;
      const minutes = Math.floor(seconds / 60).toFixed(0);

      game.actions.setState({
        elapsedTime: { seconds: seconds % 60, minutes },
      });
      secondsRef.current = seconds;
      // if (tick && seconds > state.seconds) {
      //   audioRef.current.src = tick.audio.src;
      //   audioRef.current.play();
      // }
    }
  }, [game.state.finished]);

  useEffect(() => {
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [game.state.finished]);

  return { state, actions };
}
